import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  icon?: boolean;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  icon = false,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const buttonContent = <>
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-1" />}
    </>;
  const buttonClasses = `
    inline-flex items-center justify-center
    bg-[#B85C38] text-white font-medium
    px-8 py-4 rounded-full shadow-lg hover:bg-[#9A4A2A] hover:shadow-xl
    transition-all duration-300 text-lg
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={buttonClasses} onClick={onClick} data-id="element-2">
        {buttonContent}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={buttonClasses} onClick={onClick} {...props} data-id="element-3">
      {buttonContent}
    </motion.button>;
}